import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import { FormattedMessage } from 'react-intl';
import ContentDrawer from '../ContentDrawer';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import SvgIcon from '@material-ui/core/SvgIcon';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import translations from './translations';

const DataGridExportSelection = () => {
  const intl = useIntl();
  const dataSourceContext = useDataSourceContext();
  const {
    dataExportSettings,
    showDataExportSelection,
    setShowDataExportSelection,
  } = dataSourceContext;
  const { exportTypes = ['csv'], allowExportAll = true, allowExportView = false, onExport } =
    dataExportSettings ?? {};

  /**
   * Close the export selection drawer.
   */
  const handleCloseExport = () => {
    setShowDataExportSelection(false);
  };

  /**
   * Handle the click on one of the export options.
   * @param {string} exportType
   * @param {boolean} exportAllColumns
   */
  const handleExport = (exportType, exportAllColumns = true) => {
    if (onExport && typeof onExport === 'function') {
      onExport(exportType, exportAllColumns, dataSourceContext);
    }

    setShowDataExportSelection(false);
  };

  const exportColumnsItems = allowExportView
    ? [
        ...(exportTypes.includes('csv')
          ? [
              {
                key: 'csv',
                icon: ['fal', 'file-csv'],
                name: intl.formatMessage(translations.gridActions.dataExport.csv),
                onClick: () => {
                  handleExport('csv', false);
                },
              },
            ]
          : []),
        ...(exportTypes.includes('excel')
          ? [
              {
                key: 'excel',
                icon: ['fal', 'file-excel'],
                name: intl.formatMessage(translations.gridActions.dataExport.excel),
                onClick: () => {
                  handleExport('excel', false);
                },
              },
            ]
          : []),
        ...(exportTypes.includes('pdf')
          ? [
              {
                key: 'pdf',
                icon: ['fal', 'file-pdf'],
                name: intl.formatMessage(translations.gridActions.dataExport.pdf),
                onClick: () => {
                  handleExport('pdf', false);
                },
              },
            ]
          : []),
      ]
    : [];

  const exportAllItems = allowExportAll
    ? [
        ...(exportTypes.includes('csv')
          ? [
              {
                key: 'csv',
                icon: ['fal', 'file-csv'],
                name: intl.formatMessage(translations.gridActions.dataExport.csv),
                onClick: () => {
                  handleExport('csv');
                },
              },
            ]
          : []),
        ...(exportTypes.includes('excel')
          ? [
              {
                key: 'excel',
                icon: ['fal', 'file-excel'],
                name: intl.formatMessage(translations.gridActions.dataExport.excel),
                onClick: () => {
                  handleExport('excel');
                },
              },
            ]
          : []),
      ]
    : [];

  return (
    <ContentDrawer
      isOpen={showDataExportSelection}
      handleClose={handleCloseExport}
      title={intl.formatMessage(translations.exportSelection.title)}
      drawerWidth="320px"
    >
      <MenuList>
        {allowExportView && [
          <ListSubheader disableGutters disableSticky key="exportView">
            <FormattedMessage {...translations.gridActions.dataExport.currentColumns} />
          </ListSubheader>,
          ...exportColumnsItems.map(item => (
            <MenuItem key={item.key} disableGutters onClick={item.onClick}>
              <ListItemIcon>
                <SvgIcon>
                  <FontAwesomeIcon fixedWidth icon={item.icon} />
                </SvgIcon>
              </ListItemIcon>
              <Typography variant="inherit">{item.name}</Typography>
            </MenuItem>
          )),
        ]}

        {allowExportAll && [
          <ListSubheader disableGutters disableSticky key="exportAll">
            <FormattedMessage {...translations.gridActions.dataExport.allColumns} />
          </ListSubheader>,
          ...exportAllItems.map(item => (
            <MenuItem key={item.key} disableGutters onClick={item.onClick}>
              <ListItemIcon>
                <SvgIcon>
                  <FontAwesomeIcon fixedWidth icon={item.icon} />
                </SvgIcon>
              </ListItemIcon>
              <Typography variant="inherit">{item.name}</Typography>
            </MenuItem>
          )),
        ]}
      </MenuList>
    </ContentDrawer>
  );
};

export default DataGridExportSelection;
